import { useEffect, useState } from "react";
import styles from "../../smartdevicedetails.module.css";
import { Plus, Trash2, X } from "react-feather";
import { useAuth0 } from "@auth0/auth0-react";
import axios from 'axios';
import { Controller, useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { Autocomplete, Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, FormControl, IconButton, InputLabel, MenuItem, Select, Slide, Snackbar, TextField } from "@mui/material";
import { toast } from "react-smart-toaster";

const schema = yup.object().shape({
  card_type_new: yup.string().required("This field is Required"),
  card_id: yup.object().when('card_type_new', (card_type_new) => {
    if (card_type_new && (card_type_new === "Existing")) return yup.object().required('This field is Required').nullable();
    return yup.object().nullable();
  }),
  card_type: yup.string().when('card_type_new', (card_type_new) => {
    if (card_type_new && (card_type_new === "New")) return yup.string().required('This field is Required');
    return yup.string();
  }),
  card_number: yup.string().when('card_type_new', (card_type_new) => {
    if (card_type_new && (card_type_new === "New")) return yup.string().required('This field is Required');
    return yup.string();
  }),
  card_name: yup.string().when(['card_type_new', 'card_type'], (card_type_new, card_type) => {
    if (card_type_new && (card_type_new === "Existing")) return yup.string();
    else if (card_type && (card_type === "Tenant" || card_type === "User")) return yup.string();
    return yup.string().required('This field is Required');
  }),
  tenant_info_id: yup.object().when('card_type', (card_type) => {
    if (card_type && (card_type === "Tenant")) return yup.object().required('This field is Required').nullable();
    else return yup.object().nullable();
  }),
  user_id: yup.object().when('card_type', (card_type) => {
    if (card_type && (card_type === "User")) return yup.object().required('This field is Required').nullable();
    else return yup.object().nullable();
  })
});

const TTDoorLockKeyFob = ({ deviceDetails, setLoading, noOfSync }) => {
  const { getAccessTokenSilently } = useAuth0();
  const [keyList, setKeyList] = useState([]);
  const [deleteModalOpen, setDeleteModalOpen] = useState(false);
  const [deleteId, setDeleteId] = useState(0);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMsg, setSnackbarMsg] = useState("");
  const [addKeyState, setAddKeyState] = useState(false);
  const [cardType, setCardType] = useState("");
  const [cardTypeNew, setCardTypeNew] = useState("");
  const [tenantList, setTenantList] = useState([]);
  const [keyfobList, setKeyfobList] = useState([]);
  const [userList, setUserList] = useState([]);


  const { handleSubmit, control, errors, setValue, clearErrors, setError } = useForm({
    resolver: yupResolver(schema),
    mode: "onChange"
  });

  useEffect(() => {
    const getList = async () => {
      const token = await getAccessTokenSilently({ audience: process.env.REACT_APP_AUTH0_AUDIENCE });
      await axios.get(process.env.REACT_APP_DEVICE_API_URL + "v1/ttlock/lock-key-fobs/" + deviceDetails?.id, {
        headers: {
          Authorization: `Bearer ${token}`
        }
      }).then((response) => {
        setKeyList(response.data.data);
      }).catch((error) => {
        setKeyList([]);
      });
    }

    if (deviceDetails?.id) {
      getList();
    }

  }, [deviceDetails?.id, getAccessTokenSilently]);

  useEffect(() => {
    const fetchTenantListByProperty = async () => {
      const token = await getAccessTokenSilently({ audience: process.env.REACT_APP_AUTH0_AUDIENCE });
      await axios.get(process.env.REACT_APP_DEVICE_API_URL + "v1/tenant-list-property/" + deviceDetails?.property_id, {
        headers: {
          Authorization: `Bearer ${token}`,
        }
      }).then((response) => {
        setTenantList(response.data.data);
      }).catch((error) => {
      });
    }

    const fetchTenantListByApartment = async () => {
      const token = await getAccessTokenSilently({ audience: process.env.REACT_APP_AUTH0_AUDIENCE });
      await axios.get(process.env.REACT_APP_DEVICE_API_URL + "v1/device-tenant-list/" + deviceDetails?.apt_id, {
        headers: {
          Authorization: `Bearer ${token}`,
        }
      }).then((response) => {
        let tList = response.data.data?.map(i => {
          return { id: i?.id, label: i?.full_name };
        });
        setTenantList(tList);
      }).catch((error) => {
      });
    }

    if (deviceDetails?.apt_id && deviceDetails?.apt_id > 0) {
      fetchTenantListByApartment();
    } else if (deviceDetails?.property_id && deviceDetails?.property_id > 0) {
      fetchTenantListByProperty();
    }

  }, [deviceDetails?.property_id, deviceDetails?.apt_id, getAccessTokenSilently]);

  useEffect(() => {
    const fetchUserList = async () => {
      const token = await getAccessTokenSilently({ audience: process.env.REACT_APP_AUTH0_AUDIENCE });
      await axios.get(process.env.REACT_APP_DEVICE_API_URL + "v1/user-list-property/" + deviceDetails?.property_id, {
        headers: {
          Authorization: `Bearer ${token}`,
        }
      }).then((response) => {
        setUserList(response.data.data);
      }).catch((error) => {
        if (typeof error.response !== "undefined")
          toast.error(error.response.data.message);
      });
    };

    if (deviceDetails) {
      fetchUserList();
    }
  }, [deviceDetails, getAccessTokenSilently]);

  useEffect(() => {
    const fetchKeyFobs = async () => {
      const token = await getAccessTokenSilently({ audience: process.env.REACT_APP_AUTH0_AUDIENCE });
      axios(process.env.REACT_APP_DEVICE_API_URL + "v1/ttlock/key-fobs", {
        headers: {
          Authorization: `Bearer ${token}`,
        }
      }).then((response) => {
        let keyFobListTemp = response.data.data?.map(i => {
          return { id: i?.group_id, label: i?.card_name + " - " + i?.card_number };
        });

        setKeyfobList(keyFobListTemp);
      }).catch((error) => {
        if (typeof error.response !== "undefined")
          toast.error(error.response.data.message);
      });
    };
    if (deviceDetails?.id) {
      fetchKeyFobs();
    }
  }, [getAccessTokenSilently, deviceDetails]);

  const onSubmit = async (data) => {
    let postData = {};

    if (data?.card_type_new === 'Existing') {
      postData = { ...postData, card_id: data?.card_id?.id };
    } else {
      postData = { ...postData, card_number: data.card_number };
      if (data?.card_type === 'Tenant') {
        postData = { ...postData, card_name: data?.tenant_info_id?.label, tenant_info_id: data?.tenant_info_id?.id };
      } else if (data?.card_type === 'User') {
        postData = { ...postData, card_name: data?.user_id?.label, user_id: data?.user_id?.id };
      } else {
        postData = { ...postData, card_name: data?.card_name };
      }
    }

    setLoading(true);
    const token = await getAccessTokenSilently({ audience: process.env.REACT_APP_AUTH0_AUDIENCE });

    axios.post(`${process.env.REACT_APP_DEVICE_API_URL}v1/ttlock/lock-key-fobs/${deviceDetails?.id}`, postData, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }).then((response) => {
      setLoading(false);
      setSnackbarMsg(response?.data?.message);
      setSnackbarOpen(true);

      setKeyList(prev => {
        return prev.concat(response?.data?.data);
      });

      setAddKeyState(false);
    }).catch((error) => {
      setLoading(false);
      if (error.response.status === 422) {
        setError("card_number", {
          type: "validation",
          message: error.response.data.message
        });

        return false;
      }
      if (typeof error.response !== "undefined")
        toast.error(error.response.data.message);
    });
  }

  const deleteKeyFob = async () => {
    setLoading(true);
    setDeleteModalOpen(false);
    const token = await getAccessTokenSilently({ audience: process.env.REACT_APP_AUTH0_AUDIENCE });

    axios.delete(`${process.env.REACT_APP_DEVICE_API_URL}v1/ttlock/lock-key-fobs/${deviceDetails?.id}/${deleteId}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }).then((response) => {
      setLoading(false);
      setSnackbarMsg(response?.data?.message);
      setSnackbarOpen(true);

      setKeyList(prev => {
        return prev?.filter(i => i?.id !== deleteId);
      });

      setDeleteId(0);
    }).catch((error) => {
      setLoading(false);
      if (typeof error.response !== "undefined")
        toast.error(error.response.data.message);
    });
  }

  /*const onUpdate = async (data) => {
    setLoading(true);
    const token = await getAccessTokenSilently({ audience: process.env.REACT_APP_AUTH0_AUDIENCE });

    axios.put(`${process.env.REACT_APP_DEVICE_API_URL}v1/ttlock/lock-key-fobs/${deviceDetails?.id}/${editData?.id}`, data, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }).then((response) => {
      setLoading(false);
      setSnackbarMsg(response?.data?.message);
      setSnackbarOpen(true);

      setKeyList(prev => {
        let keyListTemp = prev?.map(i => {
          if (i?.id === editData?.id)
            return { ...i, card_name: data?.card_name };
          return i;
        });
        return keyListTemp;
      });

      setAddKeyState(false);
      setEditData(null);
      setIsEdit(false);
    }).catch((error) => {
      setLoading(false);
      if (typeof error.response !== "undefined")
        toast.error(error.response.data.message);
    });
  }

  useEffect(() => {
    if (editData) {
      setValue('card_type', 'Other');
      setCardType('Other');
      setValue('card_name', editData?.card_name);
      setValue('card_number', editData?.card_number);
    } else {
      setValue('card_name', '');
      setValue('card_number', '');
    }
  }, [editData, setValue]);*/

  return (<>

    {deviceDetails?.online === 0 && (<div className={`${styles.OfflineSection}`}>
      <img src="/static/img/offline.svg" width="60px" height="60px" alt="" />
      <p>Device Is Offline</p>
    </div>)}

    {(!addKeyState && keyList?.length > 0) && <button className={`${styles.AddFingurprintBU}`} onClick={(e) => { setAddKeyState(true); }}><Plus />Key</button>}

    {(!addKeyState && keyList?.length === 0) && <div className={`${styles.NoPinSec}`}>
      <div>
        <img src="/static/img/noDoorPin.svg" alt="" />
        <p>No Key Fobs Are Available</p>
        <button onClick={(e) => { setAddKeyState(true); }}>Add Key</button>
      </div>
    </div>}

    {(!addKeyState && keyList?.length > 0) && <div className={`${styles.PinCodeListArea}`}>
      {keyList?.map(i => {
        return (<div className={`${styles.FingerprintsList}`}>
          <p className={`${styles.FingerprintsTitle}`}>{i?.card_name}</p>
          <div>
            {/*i?.is_master === 0 && <button onClick={(e) => { setAddKeyState(true); }}><Edit /></button>*/}
            {i?.is_master === 0 && <button onClick={(e) => { setDeleteModalOpen(true); setDeleteId(i?.id); }}><Trash2 /></button>}
          </div>
        </div>);
      })}
    </div>}

    {addKeyState && <div className={`${styles.Full}`}>
      <form onSubmit={handleSubmit(onSubmit)}>
        <div className={`${styles.AddKeyFobFormRow}`}>
          <div className={`${styles.TTLockPinRow}`}>
            <div className={`${styles.PinTypeSec} FormGroup`}>
              <FormControl fullWidth>
                <InputLabel id="demo-simple-select-label">Status*</InputLabel>
                <Controller
                  name="card_type_new"
                  control={control}
                  render={(field) => (
                    <Select
                      {...field}
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      label="Type*"
                      onChange={(e) => {
                        field.onChange(e);

                        setCardTypeNew(e.target.value);
                        setCardType("");
                        setValue("card_type", "");
                        clearErrors();
                      }}
                    >
                      <MenuItem value="Existing">Existing</MenuItem>
                      <MenuItem value="New">New</MenuItem>
                    </Select>
                  )}
                />
              </FormControl>
              {errors?.card_type_new && (<p className={`${styles.ErrorM}`}>{errors?.card_type_new?.message}</p>)}
            </div>
            {cardTypeNew === 'Existing' && <div className={`${styles.PinTypeSec} FormGroup`}>
              <FormControl fullWidth>
                <Controller
                  name="card_id"
                  control={control}
                  render={(field) => (<Autocomplete
                    id="free-solo-2-demo"
                    disableClearable
                    options={keyfobList}
                    renderInput={(params) => (<TextField {...params} label="Select Keyfob*" />)}
                    onChange={(event, newValue) => {
                      setValue('card_id', newValue);
                      clearErrors();
                    }}
                  />)}
                />
              </FormControl>
              {errors?.card_id && (<p className={`${styles.ErrorM}`}>{errors?.card_id?.message}</p>)}
            </div>}
          </div>

          {cardTypeNew === 'New' && <>
            <div className={`${styles.TTLockPinRow}`}>
              <div className={`${styles.PinTypeSec} FormGroup`}>
                <FormControl fullWidth>
                  <InputLabel id="demo-simple-select-label">Type*</InputLabel>
                  <Controller
                    name="card_type"
                    control={control}
                    render={(field) => (
                      <Select
                        {...field}
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        label="Type*"
                        onChange={(e) => {
                          field.onChange(e);

                          setCardType(e.target.value);
                        }}
                      >
                        <MenuItem value="Tenant">Tenant</MenuItem>
                        <MenuItem value="User">User</MenuItem>
                        <MenuItem value="Other">Other</MenuItem>
                      </Select>
                    )}
                  />
                </FormControl>
                {errors?.card_type && (<p className={`${styles.ErrorM}`}>{errors?.card_type?.message}</p>)}
              </div>
              {(cardType !== 'Tenant' && cardType !== 'User') && <div className={`${styles.PinTypeSec} FormGroup`}>
                <FormControl fullWidth>
                  <Controller
                    name="card_name"
                    control={control}
                    render={(field) => (<TextField
                      {...field}
                      id="outlined-multiline-static"
                      label="Card Name*"
                      variant="outlined"
                      value={field?.value}
                    />)}
                  />
                </FormControl>
                {errors?.card_name && (<p className={`${styles.ErrorM}`}>{errors?.card_name?.message}</p>)}
              </div>}
              {cardType === 'Tenant' && <div className={`${styles.PinTypeSec} FormGroup`}>
                <FormControl fullWidth>
                  <Controller
                    name="tenant_info_id"
                    control={control}
                    render={(field) => (<Autocomplete
                      id="free-solo-2-demo"
                      disableClearable
                      options={tenantList}
                      renderInput={(params) => (<TextField {...params} label="Tenant*" />)}
                      onChange={(event, newValue) => {
                        setValue('tenant_info_id', newValue);
                        clearErrors();
                      }}
                    />)}
                  />
                </FormControl>
                {errors?.tenant_info_id && (<p className={`${styles.ErrorM}`}>{errors?.tenant_info_id?.message}</p>)}
              </div>}
              {cardType === 'User' && <div className={`${styles.PinTypeSec} FormGroup`}>
                <FormControl fullWidth>
                  <Controller
                    name="user_id"
                    control={control}
                    render={(field) => (<Autocomplete
                      id="free-solo-2-demo"
                      disableClearable
                      options={userList}
                      renderInput={(params) => (<TextField {...params} label="Tenant*" />)}
                      onChange={(event, newValue) => {
                        setValue('user_id', newValue);
                        clearErrors();
                      }}
                    />)}
                  />
                </FormControl>
                {errors?.user_id && (<p className={`${styles.ErrorM}`}>{errors?.user_id?.message}</p>)}
              </div>}
              <div className={`${styles.PinTypeSec} FormGroup`}>
                <FormControl fullWidth>
                  <Controller
                    name="card_number"
                    control={control}
                    render={(field) => (<TextField
                      {...field}
                      id="outlined-multiline-static"
                      label="Card Number*"
                      variant="outlined"
                    />)}
                  />
                </FormControl>
                {errors?.card_number && (<p className={`${styles.ErrorM}`}>{errors?.card_number?.message}</p>)}
              </div>
            </div>

          </>}
        </div>
        <div className={`${styles.ButtonAreaPinCode}`}>
          <button type="button" onClick={(e) => { setAddKeyState(false); }} className={`${styles.ButtonVoiletLine}`}>Cancel</button>
          <button type="submit" className={`${styles.ButtonVoiletSolid}`}>Add</button>
        </div>
      </form>
    </div>}

    <Dialog
      open={deleteModalOpen}
      fullWidth
      maxWidth="sm"
      onClose={(e) => setDeleteModalOpen(false)}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      className="NewPopUp"
    >
      <DialogTitle id="alert-dialog-title">Are you sure you want to delete the key fob? <button onClick={(e) => setDeleteModalOpen(false)}><X /></button></DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description">
          <div className="ModalFormGroup">
            <label className="PopupBodyText">The key fob will be removed immediately. You can't undo this action.</label>
          </div>
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={(e) => deleteKeyFob()} className="CancelPopupBU">Delete</Button>
        <Button onClick={(e) => setDeleteModalOpen(false)} className="SubmitPopupBU">Cancel</Button>
      </DialogActions>
    </Dialog>

    <Snackbar
      open={snackbarOpen}
      onClose={(e) => setSnackbarOpen(false)}
      TransitionComponent={Slide}
      message={snackbarMsg}
      autoHideDuration={10000}
      anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
      action={
        <IconButton
          size="small"
          aria-label="close"
          color="inherit"
          onClick={(e) => setSnackbarOpen(false)}
        >
          <X />
        </IconButton>
      }
    />

  </>);
}

export default TTDoorLockKeyFob;